import { CSSObject, SerializedStyles } from '@emotion/react';
import { ReactNode } from 'react';
import { cn } from '@anytag/shared-utils';
import { SignInSignUpFooter, SignInSignUpFooterProps } from '../SignInSignUpFooter';
import { SignInSignUpHeader, SignInSignUpHeaderProps } from '../SignInSignUpHeader';

export interface SignInSignUpLayoutProps {
  className?: string;
  children: ReactNode;
  contentClassName?: CSSObject | SerializedStyles;
  headerProps?: Omit<SignInSignUpHeaderProps, 'page'>;
  footerProps?: Omit<SignInSignUpFooterProps, 'page'>;
}

export const SignInSignUpLayout = ({
  children,
  className,
  headerProps,
  footerProps,
  contentClassName
}: SignInSignUpLayoutProps) => (
  <div className={cn('box-border flex h-full w-full flex-col items-center justify-center bg-black-10', className)}>
    <SignInSignUpHeader {...headerProps} />

    <div
      className={cn(
        'relative box-border flex w-[var(--dashboard-max-width)] rounded-sm menu-filter-shadow',
        contentClassName
      )}
    >
      {children}
    </div>

    <SignInSignUpFooter {...footerProps} />
  </div>
);
